import { SVGAttributes } from 'react';

import tw, { styled } from 'twin.macro';

const HighlightContainer = styled.span`
  ${tw`absolute w-full px-2 bottom-0`}
  mix-blend-mode: multiply;
`;

type SvgProps = {
  color: string;
}

export type HighlightVariant = 'arch' | 'machete' | 'macheteInverse' | 'whale';

const defaultSvgProps: SVGAttributes<SVGSVGElement> = {
  preserveAspectRatio: 'none',
  width: '100%',
};

const arch = ({ color }: SvgProps) => (
  <svg viewBox="0 0 126 22" height="22" fill={color} {...defaultSvgProps}>
    <path d="M2.49252 12.8497C1.27629 10.048 3.14072 6.87195 6.18049 6.5672L62.7391 0.896944L112.256 0.855613C115.912 0.852561 118.538 4.372 117.494 7.87684C115.185 15.6295 107.637 20.6022 99.6039 19.6627L43.4678 13.0968C36.254 12.2531 28.9535 12.5067 21.8145 13.849L8.94179 16.2695C6.25661 16.7744 3.5802 15.3552 2.49252 12.8497Z" />
    <circle cx="122.85" cy="14.4996" r="3.15" />
  </svg>

);

const machete = ({ color }: SvgProps) => (
  <svg viewBox="0 0 132 29" height="17" fill={color} {...defaultSvgProps}>
    <path d="m1.12681,10.51577c-1.30756,-3.47774 0.76533,-7.45117 3.84192,-7.36441l122.94327,3.46709c2.461,0.06941 4.227,2.99142 3.602,5.95971c-1.405,6.66723 -6.392,11.15855 -11.912,10.72615l-113.9236,-8.92375c-1.96811,-0.15416 -3.71378,-1.63643 -4.55159,-3.86479z" />
  </svg>
);

const macheteInverse = ({ color }: SvgProps) => (
  <svg viewBox="0 0 165 24" height="24" fill={color} {...defaultSvgProps}>
    <path d="M147.562 2.07969C146.512 1.31276 145.217 0.959319 143.923 1.08688L92.6156 6.14727C83.7604 7.02064 74.8501 7.20141 65.9659 6.68792L12.5245 3.59912C10.945 3.50783 9.4656 4.37359 8.772 5.79514C4.89694 13.7372 10.6847 22.9978 19.5237 22.9981L46.1155 22.999L112.476 14.4861L143.518 14.4872C150.159 14.4874 152.925 5.99805 147.562 2.07969Z" />
  </svg>
);

const whale = ({ color }: SvgProps) => (
  <svg viewBox="0 0 109 23" height="23" fill={color} {...defaultSvgProps}>
    <path d="m0.81933,24.987c-1.46659,-2.1473 -0.75946,-5.1166 1.52573,-6.4067l7.68604,-4.33909c5.6154,-3.17016 11.8853,-4.96601 18.2936,-5.23978l76.6403,-3.27412c2.035,-0.08696 3.652,1.65998 3.415,3.6921c-0.53,4.55779 -4.023,8.23599 -8.5379,8.98929l-40.4697,6.7531l-53.61893,2.2906c-1.9668,0.084 -3.82806,-0.846 -4.93414,-2.4654z" />
  </svg>
);

const variants = {arch, machete, macheteInverse, whale};

type Props = React.ComponentPropsWithoutRef<'span'> & {
  text: string;
  color: string;
  variant?: HighlightVariant;
  containerClass?: string;
  icon?: JSX.Element;
};

export function Highlight(props: Props) {
  const Variant = variants[props.variant || 'machete'];
  return (
    <span className={`relative ${props.className || ''}`}>
      {props.icon}
      <HighlightContainer className={props.containerClass || ''}>
        <Variant color={props.color}/>
      </HighlightContainer>
      {props.text}
    </span>
  );
}
